import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ClientService } from '../client/client.service';

@Injectable()
export class ClientInfoInterceptor implements HttpInterceptor {
  readonly #blacklistUrls = [environment.apihost + environment.traderfoxApi];
  #clientService = inject(ClientService);

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.#blacklistUrls.find((url) => req.url.startsWith(url))) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        headers: req.headers
          .set('x-fz-os', this.#clientService.os)
          .set('x-fz-client', this.#clientService.client)
          .set('x-fz-appversion', this.#clientService.appVersion)
          .set('x-fz-build', this.#clientService.build),
      }),
    );
  }
}
